import {
	BaseError,
} from './BaseError';

export class GetSessionError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
